export const PARTNER_ID_PARAMETER = 'partnerId';
